module.exports = __webpack_public_path__ + "static/diy_recipe_mug_cakes_thumbnail-832bf76f10b0861eaa69a84dbedbd95b.jpg";